<script setup>
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store.js';

// Bolinha vermelha com a quantidade de não lidas, para chamar atenção no menu.
const props = defineProps({
  getter: { type: String, required: true },
});

const quantidade = useMapGetter(props.getter);
const texto = computed(() =>
  quantidade.value > 99 ? '99+' : String(quantidade.value)
);
</script>

<template>
  <span
    v-if="quantidade > 0"
    class="inline-flex items-center justify-center flex-shrink-0 h-5 min-w-5 px-1.5 rounded-full bg-n-ruby-9 text-white text-[11px] font-semibold leading-none"
    data-test="contador-nao-lidas"
  >
    {{ texto }}
  </span>
</template>
